import { Controller } from "stimulus"

const SHARE_ON_FACEBOOK = "[data-share-facebook]"
const SHARE_ON_TWITTER = "[data-share-twitter]"
const SHARE_ON_WHATSAPP = "[data-share-whatsapp]"
const SHARE_ON_REDDIT = "[data-share-reddit]"
const SHARE_ON_PINTEREST = "[data-share-pinterest]"
const SHARE_ON_EMAIL = "[data-share-email]"
const SHARE_ON_COPY = "[data-share-copy]"

export default class extends Controller {
  static targets = ['panel']
  shouldAddGlobalClickListener = false;

  connect() {
    window.addEventListener('closeAllDropdowns', this.hiddenDisplayBound = this.hiddenDisplay.bind(this))
    document.addEventListener('click', this.handleOutsideClickBound = this.handleOutsideClick.bind(this))
  }

  disconnect() {
    window.removeEventListener('closeAllDropdowns', this.hiddenDisplayBound)
    document.removeEventListener('click', this.handleOutsideClickBound)
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hiddenDisplay()
    }
  }

  dropdownBtnClicked(e) {
    e.preventDefault()
    e.stopPropagation()

    // 廣播關閉所有 dropdown
    window.dispatchEvent(new Event('closeAllDropdowns'))

    // 再打開自己
    this.toggleDisplay()

    if (!this.globalClickListenerAdded) {
      document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains("role-tabs-button")) {
          event.preventDefault()
          return;
        }
        this.hiddenDisplay()
      });
      this.globalClickListenerAdded = true;
    }
  }

  dropdownSharedBtnClicked(e) {
    e.preventDefault()
    e.stopPropagation()

    window.dispatchEvent(new Event('closeAllDropdowns'))

    this.toggleDisplay()

    this.shareOnFacebook()
    this.shareOnTwitter()
    this.shareOnWhatsapp()
    this.shareOnReddit()
    this.shareOnPinterest()
    this.shareOnEmail()
    this.shareOnCopy()
  }

  hiddenDisplay() {
    this.element.classList.add('close')
    this.panelTarget.classList.add('hidden')
  }

  toggleDisplay() {
    this.element.classList.toggle('close')
    this.panelTarget.classList.toggle('hidden')
  }

  shareOnFacebook () {
    const $elements = document.querySelectorAll(SHARE_ON_FACEBOOK)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postLink = e.target.parentElement.parentElement.dataset.link

        window.trackingEvent.share({
          method: 'facebook',
          content_type: 'post',
          item_id: postLink,
        })

        FB.ui({
          method: "share",
          href: postLink,
        })
      })
    )
  }

  shareOnTwitter () {
    const $elements = document.querySelectorAll(SHARE_ON_TWITTER)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postEl = e.target.parentElement.parentElement
        const postLink = postEl.dataset.link

        window.trackingEvent.share({
          method: 'twitter',
          content_type: 'post',
          item_id: postLink,
        })

        window.open(
          `https://twitter.com/share?url=${postEl.dataset.link}&text=${postEl.dataset.title}`,
          "_blank"
        )
      })
    )
  }

  shareOnWhatsapp () {
    const $elements = document.querySelectorAll(SHARE_ON_WHATSAPP)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postLink = e.target.parentElement.parentElement.dataset.link

        window.trackingEvent.share({
          method: 'whatsapp',
          content_type: 'post',
          item_id: postLink,
        })

        window.location.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(postLink)}`
      })
    )
  }

  shareOnReddit () {
    const $elements = document.querySelectorAll(SHARE_ON_REDDIT)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postEl = e.target.parentElement.parentElement
        const postLink = postEl.dataset.link

        window.trackingEvent.share({
          method: 'reddit',
          content_type: 'post',
          item_id: postLink,
        })

        window.open(
          `https://reddit.com/submit?url=${encodeURIComponent(postLink)}&title=${postEl.dataset.title}`,
          "_blank"
        )
      })
    )
  }

  shareOnPinterest () {
    const $elements = document.querySelectorAll(SHARE_ON_PINTEREST)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postEl = e.target.parentElement.parentElement
        const postLink = postEl.dataset.link

        window.trackingEvent.share({
          method: 'pinterest',
          content_type: 'post',
          item_id: postLink,
        })

        window.open(
          `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(postLink)}&media=${encodeURIComponent(postEl.dataset.image)}&description=${encodeURIComponent(postEl.dataset.title)}`,
          "_blank"
        )
      })
    )
  }

  shareOnEmail () {
    const $elements = document.querySelectorAll(SHARE_ON_EMAIL)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        const postEl = e.target.parentElement.parentElement
        const postLink = postEl.dataset.link

        window.open(
          `mailto:?subject=${postEl.dataset.title}&body=${postLink}`,
          "_blank"
        )
      })
    )
  }

  shareOnCopy () {
    const $elements = document.querySelectorAll(SHARE_ON_COPY)
    if (!$elements) {
      return
    }

    $elements.forEach((item) =>
      item.addEventListener("click", (e) => {
        e.preventDefault()

        e.target.firstElementChild.style.visibility = "visible"
        setTimeout(function () {
          e.target.firstElementChild.style.visibility = "hidden"
        }, 1000)

        const postEl = e.target.parentElement.parentElement
        const postLink = postEl.dataset.link

        navigator.clipboard.writeText(postLink)
      })
    )
  }
}
